import { isFalsy } from '../../Helpers/helpers';
import isAllLowerCase from './isAllLowerCase';
import isCamelCase from './isCamelCase';

/**
 * Converts a camelCase string to Title Case
 * @function camelToTitleCase
 * @param {string} camelCase
 * @return {string}
 * @example camelToTitleCase('testString') => 'Test String'
 * @example camelToTitleCase('test') => 'Test' -- DOES Handle All LowerCase Inputs
 * @example camelToTitleCase('TEST') => 'TEST' -- Does NOT Handle All Uppercase Inputs
 */
const camelToTitleCase = (camelCase) => {
  if (isFalsy(camelCase)) return '';
  if (isFalsy(isAllLowerCase(camelCase)) && isFalsy(isCamelCase(camelCase))) return camelCase;

  return camelCase
    .replace(/([A-Z])/g, (match) => ` ${match}`)
    .replace(/^./, (match) => match.toUpperCase());
};

export default camelToTitleCase;
